import { Directive, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Directive({
    selector: '[isRestricted]',
    standalone: false
})
export class IsRestrictedDirective implements OnInit {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) { }

  public ngOnInit(): void {

    if (this.authService.isRestricted()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
